import React from 'react';
import './FinanceNavSidebar.css';

interface FinanceNavSidebarProps {
  selectedSubCategory: string;
  onSubCategoryChange: (sub: string) => void;
  counts?: Record<string, number>;
  totalCount?: number;
}

// Icons removed for a cleaner, text-only sidebar

const FinanceNavSidebar: React.FC<FinanceNavSidebarProps> = ({ selectedSubCategory, onSubCategoryChange, counts: _counts = {}, totalCount: _totalCount }) => {
  const isActive = (sub: string) => selectedSubCategory === sub;

  const SUBS = [
    'Daily','Monthly','Stocks','Earnings','Commodities','Acquisitions','Earnings Calls','IPOs','Fed Rates','Prediction Markets','Treasuries'
  ];

  return (
    <div className="finance-sidebar">
      <div
        className={`finance-sidebar-item ${selectedSubCategory === '' ? 'active' : ''}`}
        onClick={() => {
          onSubCategoryChange('');
          try { (window as any).posthog?.capture('engagement:secondary_category_selected', { category: 'Finance', sub_category: 'All' }); } catch {}
        }}
      >
        <span className="finance-label">All</span>
      </div>

      {SUBS.map(sub => (
        <div
          key={sub}
          className={`finance-sidebar-item ${isActive(sub) ? 'active' : ''}`}
          onClick={() => {
            onSubCategoryChange(sub);
            try { (window as any).posthog?.capture('engagement:secondary_category_selected', { category: 'Finance', sub_category: sub }); } catch {}
          }}
        >
          <span className="finance-label">{sub}</span>
        </div>
      ))}
    </div>
  );
};

export default FinanceNavSidebar;


